<template>
    <div id="nav" class="position-fixed">
        <b-navbar type="dark" fixed="top">
            <b-navbar-brand href="https://www.h3.solutions">
                <img src="../assets/logo-light-sm.png" alt="H3 Solutions logo">
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <b-nav-item @click="menuHidden =! menuHidden">MENU</b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <transition name="fadeIn" mode="in-out">
            <div v-if="!menuHidden" class="d-flex align-items-center black-bg nav-container overflow-hidden position-absolute">
                <ul class="main-nav">
                    <li><router-link to="/">{{ navItems.links[0] }}</router-link></li>
                    <li><router-link to="/about">{{ navItems.links[1] }}</router-link></li>
                    <li><router-link to="/services">{{ navItems.links[2] }}</router-link></li>
                    <li><router-link to="/blog">{{ navItems.links[3] }}</router-link></li>
                    <li id="lang" @hover="showLangBlock" class="position-relative">
                        <a>{{ navItems.links[4] }}</a>
                        <span class="dropdown-menu">
                            <p class="dropdown-item-text" @click="setLang('HR')">{{ navItems.lang[0] }}</p>
                            <span class="dropdown-divider"></span>
                            <p class="dropdown-item-text" @click="setLang('ENG')">{{ navItems.lang[1] }}</p>
                        </span>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Navigation",
        props: {
            webData: {
                type: Object,
                reqired: true
            }
        },
        data () {
            return {
                navItems: this.webData.components.navigation,
                menuHidden: true,
                showLangBlock: false
            }
        },
        watch: {
          $route () {
              this.menuHidden = true;
          }
        },
        methods: {
            setLang (state) {
                console.log('state: ', state);
                this.$store.commit('toggleLang', state);
                this.menuHidden = true;
                this.navItems = this.$store.getters.activeLang.components.navigation;
                this.$emit('langChange', true);
            }
        }
    }
</script>

<style scoped>
    #nav, .nav-wrapper div {
        top: 0;
        left: 0;
        width: 100%;
        background: transparent;
        z-index: 999;
    }
    .nav-wrapper {
        width: 100%;
        height: 80px;
        padding: 5px 80px;
    }
    .nav-container {
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 99;
    }
    .main-nav {
        margin: 0 auto;
    }
    .main-nav li {
        margin: 0 25px;
        float: left;
        text-transform: uppercase;
    }
    .main-nav li a, #lang a {
        color: rgba(255, 255, 255, .75);
        transition: 500ms ease;
    }
    .main-nav li a:hover {
        color: rgba(255, 255, 255, 1);
    }
    #lang p, #lang a {
        text-transform: uppercase;
        cursor: pointer;
    }
    #lang .dropdown-menu {
        background-color: #0C0C0C;
        opacity: 0;
        transition: 500ms ease;
        display: block;
    }
    #lang .dropdown-menu p {
        color: #fff;
    }
    #lang:hover > .dropdown-menu {
        opacity: 1;
    }

</style>